import { Component, OnInit } from "@angular/core";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { Menu } from "./menu";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";

@Component({
  selector: "app-side-bar-account",
  templateUrl: "./side-bar-account.component.html",
  styleUrls: ["./side-bar-account.component.scss"],
  animations: [
    trigger("slide", [
      state("up", style({ height: 0 })),
      state("down", style({ height: "*" })),
      transition("up <=> down", animate(200)),
    ]),
  ],
})
export class SideBarAccountComponent implements OnInit {
  currentEmployee: Employee = new Employee();
  menus = [];
  MyPermissions: string[];

  constructor(
    public sidebarservice: Menu,
    private _keycloakService: KeycloakService,
    private _employeeService: EmployeeService
  ) {
    this.getCurrentEmployee();
    this.menus = sidebarservice.getMenuList();
    this.MyPermissions = _keycloakService.getAccessPermissions();
  }

  ngOnInit() {
    // Set active menu before first change detection to avoid
    // ExpressionChangedAfterItHasBeenCheckedError on class="{{menu.active}}"
    this.toggleActiveLink();
  }

  getCurrentEmployee() {
    this._employeeService.getCurrentEmployee().subscribe(
      (data) => {
        this.currentEmployee = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  logout() {}

  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }

  getState(currentMenu) {
    if (currentMenu.active == "open") {
      return "down";
    } else {
      return "up";
    }
  }

  toggle(currentMenu) {
    this.menus.forEach((element) => {
      if (element === currentMenu) {
        currentMenu.active = "open";
      } else {
        element.active = "";
      }
    });
  }

  toggleSubmenu(currentMenu, subMenu) {
    this.toggle(currentMenu);

    currentMenu.submenus.forEach((element) => {
      if (element === subMenu) {
        subMenu.active = "active";
      } else {
        element.active = "";
      }
    });
  }

  /**
   *
   */

  toggleActiveLink() {
    const link = String(window.location.href);

    this.menus.forEach((element) => {
      if (element.type === "dropdown") {
        let currentMenu = null;
        let subMenu = element.submenus.find(
          (y) => window.location.origin + "/#" + y.Url == link
        );

        if (subMenu != null) {
          currentMenu = element;

          currentMenu.submenus.forEach((elem) => {
            if (elem === subMenu) {
              currentMenu.active = "open";
              subMenu.active = "active";
            }
          });
        }
      }

      if (
        element.type === "simple" &&
        window.location.origin + "/#" + element.Url === link
      ) {
        element.active = "open";
      }
    });
  }
}
